export default {
  moduleName: 'dashboard',
  apis: [
      {
          funName: 'info',
          methodType: 'get',
          url: '/'
      }
  ]
}